// --------------------------------------------------------------
// Created On: 2023-01-27
// Author: Zachary Thomas
//
// Last Modified: 2026-03-31
// Modified By: Dimitra Weinstein
//
// Copyright 2025 - 2026 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";

// Explains what a Lift Station report is.
export default function HelpLiftStationReport(): Component {
  return (
    <div>
      <p className="px-3 my-2">Reports can be setup to send emails with asset data periodically.</p>
      <p className="px-3 mt-3 mb-2">
        <b>Email Addresses:</b> This is a list of the email addresses that will receive this report.
      </p>
      <p className="px-3 mt-3 mb-2">
        <b>Schedule:</b> The schedule will determine what day of the month to send out the report to each listed email
        address. The report will cover all activity for the selected asset for the entire previous month.
      </p>
      <p className="px-3 mt-3 mb-2">
        <b>Project Details:</b> The email that is sent out will include details about the project. These details will
        include the location, assigned sewer basin, approved pump run time, horsepower, discharge, voltage, force main,
        tank storage volume as well as the name of the inspector for the project.
      </p>
      <p className="px-3 mt-3 mb-2">
        <b>Asset Details:</b> The email that is sent out will include details about the project asset, the selected
        number of pumps related to the asset (maximum of 2), and each pump&#39;s capacity (gpm).
      </p>
      <p className="px-3 mt-3 mb-2">
        <b>Content:</b> Report emails will contain a Microsoft Excel spreadsheet that shows the project data from the
        previous month.
      </p>
    </div>
  );
}
